export default "__VITE_ASSET__CYF4kn0C__"